import {environment as defaultEnvironment} from './environment';
import * as _ from 'lodash';


export const environmentLoader = new Promise<any>((resolve, reject) => {

  if (defaultEnvironment.production) {

    // eslint-disable-next-line one-var
    const xmlhttp = new XMLHttpRequest(),
      method = 'GET',
      url = './assets-front/environments/environment.json';

    xmlhttp.open(method, url, false);
    xmlhttp.onload = () => {
      if (xmlhttp.status === 200) {
        const customEnv = JSON.parse(xmlhttp.responseText);
        resolve(_.merge(defaultEnvironment, customEnv));
      } else {
        resolve(defaultEnvironment);
      }
    };

    xmlhttp.send();
  } else {
    resolve(defaultEnvironment);
  }
});
